module.exports = __webpack_public_path__ + "static/media/HCMM881.62a48350.jpg";